module.exports = __webpack_public_path__ + "static/media/Produtos7.6f90efa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadProdutos/Produtos7.png
// module id = 2007
// module chunks = 0